import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import { Link, useLocation } from "react-router-dom";

// question and emoji space
// bigger emoji spacing between the emoji
// sad face -> confused emoji
// emoji is not rendering

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    padding: theme.spacing(1),
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  input: {
    width: "100%",
    height: 40,
    marginBottom: 40,
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
  submitbutton: {
    width: "100%",
    height: 40,
    backgroundColor: "lightgreen",
    border: "0",
    marginBottom: 20,
  },
  danger: {
    alignItems: "center",
    justifyContent: "center",
    color: "red",
  },
}));

export default function Form(props) {
  const location = useLocation();
  const [visibility, setVisibility] = useState(true);
  const [formData, setFormData] = useState({
    email: "",
    organisation: "/org" + location.pathname,
  });

  const { email } = formData;
  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const [error, setError] = useState(false);
  const classes = useStyles();
  const rootRef = React.useRef(null);
  const onSubmit = async (e) => {
    setVisibility(false);
    props.clickButton();
    console.log(email);
    e.preventDefault();
    try {
      const response = await fetch(
        // "https://quiz-mesh.herokuapp.com/",
        "https://mesh-okr-core-lead.mesh.ai/coreLead",
        {
          method: "POST",

          headers: {
            "Access-Control-Allow-Origin": "*",
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: email,
            q1: props.ans1,
            q2: props.ans2,
            q3: props.ans3,
            q4: props.ans4,
            q5: props.ans5,
            q6: props.ans6,
            q7: props.ans7,
            q8: props.ans8,
            q9: props.ans9,
            q10: props.ans10,
            q11: props.ans11,
            q12: props.ans12,
            q13: props.ans13,
          }),
        }
      );

      const data = await response.json();
      if (response.ok) {
        console.log(data);
        setVisibility(false);
      }
    } catch (err) {
      setError(true);
      console.log(err.message);
    }
  };
  if (visibility) {
    return (
      <Modal
        // style={{ display: visibility }}
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open
        aria-labelledby="server-modal-title"
        aria-describedby="server-modal-description"
        className={classes.modal}
        style={{ padding: "50px", backgroundColor: "rgba(0,0,0,0.9)" }}
        container={() => rootRef.current}
      >
        <div className={classes.paper}>
          <p id="server-modal-description" style={{ textAlign: "center" }}>
            <b>Enter your work email to get your company's core value</b>
          </p>
          <form onSubmit={(e) => onSubmit(e)}>
            <input
              className={classes.input}
              type="email"
              name="email"
              placeholder="Email Address"
              value={email}
              onChange={(e) => onChange(e)}
              required
            ></input>
            <input
              type="submit"
              className={classes.submitbutton}
              value="Submit"
            />
          </form>
        </div>
      </Modal>
    );
  } else {
    return <div></div>;
  }
}
